/* KleenKick V3 — Sticky CTA Mobile: visibile după hero, hide pe secțiuni cu CTA proprii */
(function () {
  'use strict';

  const sticky = document.getElementById('kk-sticky-cta');
  if (!sticky) return;

  // Only on mobile
  const mobileMQ = window.matchMedia('(max-width: 767px)');
  if (!mobileMQ.matches) return;

  const hero = document.getElementById('hero');
  const product = document.getElementById('produs');
  const ctaFinal = document.querySelector('.kk-cta-final');

  if (!hero) return;

  document.body.classList.add('kk-has-sticky-cta');

  function onScroll() {
    const heroBottom = hero.getBoundingClientRect().bottom;
    const showAfterHero = heroBottom < 0;

    // Hide when product or cta-final visible (avoid CTA duplication)
    const productRect = product ? product.getBoundingClientRect() : null;
    const ctaFinalRect = ctaFinal ? ctaFinal.getBoundingClientRect() : null;
    const vh = window.innerHeight;
    const productVisible = productRect && productRect.top < vh * 0.8 && productRect.bottom > vh * 0.2;
    const ctaFinalVisible = ctaFinalRect && ctaFinalRect.top < vh * 0.8 && ctaFinalRect.bottom > vh * 0.2;

    if (showAfterHero && !productVisible && !ctaFinalVisible) {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => { onScroll(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });

  onScroll();
})();
